import { createApiClient } from "@jod/api-client";
import { getAuthToken } from "./auth-token.ts";
import { apiMode, assertBackendModeReady, env } from "./env.ts";

assertBackendModeReady(apiMode);

/** Shared, type-safe API client bound to the configured base URL + staff token. */
export const api = createApiClient({
  baseUrl: env.apiBaseUrl,
  getAuthToken,
});

api.use({
  async onRequest({ request }) {
    if (env.isDev) {
      // Local Rust API slices currently accept explicit dev headers only when
      // `allow_dev_auth_headers` is enabled. Production builds omit these.
      request.headers.set("x-dev-staff-id", "aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa");
      request.headers.set("x-dev-staff-role", "manager");
    }
    return request;
  },
});
